import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../../api/index";

const Adminrider = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const fetchUsers = async (pageNumber) => {
    try {
      setLoading(true);
      setError("");
      const res = await api.getAllUsersrider(pageNumber, 20); // ✅ rider-only backend
      if (res.data.success) {
        setUsers(res.data.riders  || []);
        setTotalPages(res.data.totalPages || 1);
        setTotalUsers(res.data.totalRiders || 0); // ✅ FIX: use backend totalRiders
      } else {
        setError("Failed to load riders.");
      }
    } catch (err) {
      setError("⚠️ Could not load riders. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(page);
  }, [page]);

  // Filter riders by Name
  const filteredUsers = users.filter((user) =>
    user.Name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="mb-4 px-4 py-2 rounded-lg hover:bg-gray-300 transition"
      >
        ← Back
      </button>

      <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">
        All Riders
      </h1>

      {/* Total Riders */}
      <p className="text-center text-gray-600 mb-4">
        Total Riders: {totalUsers}
      </p>

      {/* Search Filter */}
      <div className="max-w-2xl mx-auto mb-6">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by Name..."
          className="w-full p-2 border rounded-lg shadow-sm focus:outline-none focus:ring focus:border-blue-300"
        />
      </div>

      {loading ? (
        <p className="text-center text-gray-600">Loading riders...</p>
      ) : error ? (
        <p className="text-center text-red-500">{error}</p>
      ) : (
        <>
          {/* Riders Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {filteredUsers.map((user) => (
              <div
                key={user._id}
                className="bg-white rounded-xl shadow-md p-5 flex flex-col gap-3 hover:shadow-lg transition"
              >
                <div className="flex items-center gap-4">
                  <img
                    src={
                      user.profileImage
                        ? `${user.profileImage}`
                        : "https://res.cloudinary.com/dvuq6vmiy/image/upload/v1758633376/ChatGPT_Image_Sep_23_2025_06_14_30_AM_sef3w0.png"
                    }
                    alt={user.Name}
                    className="w-16 h-16 rounded-full object-cover border"
                  />
                  <div>
                    <h2 className="text-lg font-semibold text-gray-800">
                      {user.Name}
                    </h2>
                    <p className="text-gray-600 text-sm">{user.Email}</p>
                    <span className="inline-block mt-2 px-3 py-1 text-xs font-medium rounded-full bg-purple-100 text-purple-700">
                      Rider
                    </span>
                  </div>
                </div>

                {/* Date created */}
                <p className="text-xs text-gray-500">
                  Joined:{" "}
                  {user.createdAt
                    ? new Date(user.createdAt).toLocaleDateString()
                    : "N/A"}
                </p>
              </div>
            ))}
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-center items-center gap-4 mt-8">
            <button
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
              className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 disabled:opacity-50"
            >
              Prev
            </button>
            <span className="text-gray-700 font-medium">
              Page {page} of {totalPages}
            </span>
            <button
              onClick={() =>
                setPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={page === totalPages}
              className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Adminrider;
